module.exports = __webpack_public_path__ + "img/bg.7d2c83d2.png";